import { jsx as _jsx } from "react/jsx-runtime";
import './PanelIcon.scss';
import { SIZE } from '../../constants';
import { Icon } from '../icon/Icon';
export function PanelIcon(props) {
    return (_jsx("div", { className: 'sg-panelIcon', children: _jsx(Icon, { element: props.icon, size: SIZE.MED }) }));
}
//# sourceMappingURL=PanelIcon.js.map